<div class="modal-header">
    <h4 class="modal-title" id="mondalAddCampaignTitle">Usuario(s) siguiente a dar VoBo en <strong> {{data.fase}} - {{data.area}}</strong></h4>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<mat-dialog-content>
    <div class="modal-body">

        <div *ngFor="let x of data.usuarios">
            <label>{{x.name}}</label>
        </div>
        
    </div>
</mat-dialog-content>
